import enquireJs from 'enquire.js'
import userManager from '@/user/UserManager'
import { h } from 'vue'
import { Modal } from 'ant-design-vue'
import { LoadingOutlined, CheckCircleFilled } from '@ant-design/icons-vue'
import request from './request'

export function throttle(fn: Function, delay: number) {
  let valid = true
  return function () {
    if (!valid) {
      return false
    }
    valid = false
    setTimeout(() => {
      fn()
      valid = true
    }, delay)
  }
}

export const queryMedia = (callback: any) => {
  enquireJs
    .register(`screen and (min-width: 1600px)`, () => {
      callback('xxl')
    })
    .register(`screen and (min-width: 1200px) and (max-width: 1600px)`, () => {
      callback('xl')
    })
    .register(`screen and (min-width: 992px) and (max-width: 1200px)`, () => {
      callback('lg')
    })
    .register(`screen and (min-width: 768px) and (max-width: 992px)`, () => {
      callback('md')
    })
    .register(`screen and (min-width: 576px) and (max-width: 768px)`, () => {
      callback('sm')
    })
    .register(`screen and (max-width: 576px)`, () => {
      callback('xs')
    })
}

export const AxixValueFormatter = (value: any) => {
  if (value >= 1000000000) {
    return Math.round(value / 1000000000) + 'B'
  } else if (value >= 1000000) {
    return Math.round(value / 1000000) + 'M'
  } else if (value >= 1000) {
    return Math.round(value / 1000) + 'K'
  } else {
    return value
  }
}

export const AxixValueFormatterFixed = (value: any, fix: number) => {
  if (value >= 1000000000) {
    return (value / 1000000000).toFixed(fix) + 'B'
  } else if (value >= 1000000) {
    return (value / 1000000).toFixed(fix) + 'M'
  } else if (value >= 1000) {
    return (value / 1000).toFixed(fix) + 'K'
  } else {
    return value
  }
}

// 千分位格式化
export const toThousands = (number: number | string) => {
  var numString = (number || 0).toString(),
    result = ''
  const numberArr = numString.split('.')
  let int = numberArr[0]
  const reg = /\B(?=(\d{3})+(?!\d))/g

  result = int.replace(reg, ',')

  if (numberArr[1]) {
    result = result + '.' + numberArr[1]
  }
  return result
}

// 序列化 url search
export const queryString = (search: string) => {
  let res: any = {}
  const searchPart = search.split('?')[1]

  if (searchPart) {
    decodeURI(searchPart)
      .split('&')
      .map((item) => {
        const arr: string[] = item.split('=')
        res[arr[0]] = decodeURIComponent(arr[1])
      })
  }

  return res
}

type exportConfig = {
  url: string
  method?: 'get' | 'POST'
  target?: '_self' | '_blank'
  params?: Record<string | number | symbol, any>
  filename?: string
}
// excel 导出
export const ExcelExport = async (config: exportConfig) => {
  const { url, params = {} } = config
  const urlParams = new URLSearchParams(url.includes('?') ? url.split('?')[1] : '')
  const filename = config.filename
    || urlParams.get('tableName')
    || url.split('/').pop()?.split('?')[0]
    || 'export'
  const loadingModal = Modal.info({
    title: '正在导出',
    content: '文件准备中，请稍候...',
    centered: true,
    closable: false,
    maskClosable: false,
    icon: h(LoadingOutlined, { style: { color: '#faad14', fontSize: '22px' } }),
  })

  try {
    const resp = await request.post(url, params, {
      responseType: 'arraybuffer',
      timeout: 30 * 60 * 1000
    })
    const buffer = resp as ArrayBuffer

    // 检测后端返回的是文件还是文字（错误信息）
    // xlsx/docx 是 ZIP 格式，magic bytes 为 PK（0x50 0x4B）
    // 旧版 xls/doc 是 OLE2 格式，magic bytes 为 D0 CF
    const bytes = new Uint8Array(buffer, 0, 4)
    const isFile = (bytes[0] === 0x50 && bytes[1] === 0x4B) ||
                   (bytes[0] === 0xD0 && bytes[1] === 0xCF)

    if (!isFile) {
      loadingModal.destroy()
      let serverMsg = new TextDecoder('utf-8').decode(buffer)
      try {
        const json = JSON.parse(serverMsg)
        serverMsg = json.Message || json.message || json.Error || json.error || serverMsg
      } catch {}
      Modal.warning({ title: '导出提示', content: serverMsg, centered: true })
      return
    }

    loadingModal.update({
      title: '导出成功',
      content: '文件已下载，请查看下载目录',
      icon: h(CheckCircleFilled, { style: { color: '#52c41a', fontSize: '22px' } }),
    })
    ExprotResp(buffer, filename.replace(/\.xlsx$/i, ''))
    setTimeout(() => loadingModal.destroy(), 1500)
  } catch {
    loadingModal.destroy()
    Modal.error({ title: '导出失败', content: '请检查网络连接后重试', centered: true })
  }
}

var rbracket = /\[\]$/,
  rCRLF = /\r?\n/g,
  op = Object.prototype,
  ap = Array.prototype,
  aeach = ap.forEach,
  ostring = op.toString

function isFunction(it) {
  return ostring.call(it) === '[object Function]'
}

function isArray(it) {
  return ostring.call(it) === '[object Array]'
}

function isObject(it) {
  return ostring.call(it) === '[object Object]'
}

/**
 * @description 另一种导出，ParamClass.param 对标旧版 $.param
 * @return {*}
 */
class ParamClass {
  constructor() { }

  buildParams(prefix, obj, traditional, add) {
    var name
    let _this = this
    if (isArray(obj)) {
      // Serialize array item.
      aeach.call(obj, function (v, i) {
        if (traditional || rbracket.test(prefix)) {
          // Treat each array item as a scalar.
          add(prefix, v)
        } else {
          // Item is non-scalar (array or object), encode its numeric index.
          _this.buildParams(
            prefix + '[' + (typeof v === 'object' && v != null ? i : '') + ']',
            v,
            traditional,
            add
          )
        }
      })
    } else if (!traditional && isObject(obj)) {
      // Serialize object item.
      for (name in obj) {
        this.buildParams(prefix + '[' + name + ']', obj[name], traditional, add)
      }
    } else {
      // Serialize scalar item.
      add(prefix, obj)
    }
  }

  // Serialize an array of form elements or a set of
  // key/values into a query string
  param(a, traditional?) {
    var prefix
    var s = []
    var add = function (key, valueOrFunction) {
      // If value is a function, invoke it and use its return value
      var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction

      s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value == null ? '' : value)
    }

    // If an array was passed in, assume that it is an array of form elements.
    if (isArray(a)) {
      // Serialize the form elements
      aeach.call(a, function (item) {
        add(item.name, item.value)
      })
    } else {
      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in a) {
        this.buildParams(prefix, a[prefix], traditional, add)
      }
    }

    // Return the resulting serialization
    return s.join('&')
  }
}

export const paramClass = new ParamClass()

// 将Object 转成 Url search
export const cptSearhStr = (obj) => {
  let res = []
  for (let key in obj) {
    res.push(`${key}=${obj[key]}`)
  }
  return res.join('&')
}

export const buildFormData = (obj) => {
  const bodyFormData = new FormData()

  for (let key in obj) {
    bodyFormData.append(key, obj[key])
  }

  return bodyFormData
}

export function openWindow(urlParam, type) {
  var url = urlParam.slice(0, urlParam.indexOf('?'))
  var param = urlParam.slice(urlParam.indexOf('?') + 1).split('&')
  var tempForm = document.createElement('form')
  tempForm.id = 'tempForm1'
  tempForm.method = 'post'
  tempForm.action = url
  tempForm.target = type
  var hash
  for (var i = 0; i < param.length; i++) {
    hash = param[i].split('=')
    var hideInput = document.createElement('input')
    hideInput.type = 'hidden'
    hideInput.name = hash[0]
    hideInput.value = hash[1]
    tempForm.appendChild(hideInput)
  }
  if (document.all) {
    // 兼容不同浏览器
    tempForm.attachEvent('onsubmit', function () { }) //IE
  } else {
    tempForm.addEventListener('submit', function () { }, false) //firefox
  }
  document.body.appendChild(tempForm)
  if (document.all) {
    // 兼容不同浏览器
    tempForm.fireEvent('onsubmit')
  } else {
    tempForm.dispatchEvent(new Event('submit'))
  }
  tempForm.submit()
  document.body.removeChild(tempForm)
}

export const generateNumberAarray = (end: number, start: number = 1) => {
  return Array.from(new Array(end + 1).keys()).slice(start)
}

export const isFromDCCenter = (): boolean => {
  return location.href.indexOf('DCCenter') > -1
}

// 从 url 上获取参数来初始化 formState
export const GetSearchReactive = (params = {}) => {
  const searchObj = queryString(window.location.search)
  console.log('searchObj', searchObj)
  Object.keys(searchObj).forEach((key) => {
    if (params.hasOwnProperty(key)) {
      params[key] = searchObj[key]
    }
  })
  return params
}

// 处理后端返回 arraybuffer 生产 Excel
export const ExprotResp = (data: ArrayBuffer, fileName: string) => {
  // 处理返回的文件流
  var blob = new Blob([data], {
    type: 'application/msword;charset=utf-8'
  })
  fileName += '.xlsx'
  var alink = document.createElement('a')
  var url = window.URL.createObjectURL(blob)
  alink.href = url
  alink.download = fileName
  var body = document.getElementsByTagName('body')[0]
  body.appendChild(alink)
  alink.click()
  body.removeChild(alink)
  window.URL.revokeObjectURL(url)
}
